// GPA+ brand + institutional assets (official, user-provided).
export const GPA_LOGO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_gpa-plus-skills/artifacts/ctaczwhh_GPA%2B%20Logo%204.png";
export const LSC_LOGO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_gpa-plus-skills/artifacts/myvjju79_lone%20star%20college%20logo.png";
export const NUTT_PHOTO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_gpa-plus-skills/artifacts/rw0i08j9_lee-ann-nutt-edd.jpg";
export const PRESENTER =
  "https://static.prod-images.emergentagent.com/jobs/69aac895-42cc-43ce-b8ea-745bf2a06245/images/fd87d68745fe59c6ca572c34ee9e2802cd4e9c968a07b2cadaa08609a9d8b4c6.jpeg";

// Generated hero + emblem (fallback / decorative).
export const EMBLEM =
  "https://static.prod-images.emergentagent.com/jobs/69aac895-42cc-43ce-b8ea-745bf2a06245/images/cef7ad893bb03ce5b3434edc4438179ac5bb28d380a81a1a009d22118e3a57e7.jpeg";
export const HERO =
  "https://static.prod-images.emergentagent.com/jobs/69aac895-42cc-43ce-b8ea-745bf2a06245/images/7f216058457e7b3110097a0c5b30b9db5abd472d4f66152d8cf49b74401cb154.jpeg";

// Lone Star College student photos (served locally from /public/students)
export const STUDENT_PHOTOS = {
  stairs: "/students/stairs.webp",
  group: "/students/group.webp",
  phone: "/students/phone.webp",
  lab: "/students/lab.webp",
  books: "/students/books.webp",
};

// Full-width dark topic banners for marketing sub-pages
export const PAGE_BANNERS = {
  framework: "https://static.prod-images.emergentagent.com/jobs/69aac895-42cc-43ce-b8ea-745bf2a06245/images/981a9c2080ee6207abfdabfb577595fc59a6a6a441ca3b7f9bfd9d2ffad74ff0.jpeg",
  tsb: "https://static.prod-images.emergentagent.com/jobs/69aac895-42cc-43ce-b8ea-745bf2a06245/images/f2363d784afe50a5ec1e483b4bb3ae71fb7f4e1c255fa99f8f6bb36fc79c8c38.jpeg",
  research: "https://static.prod-images.emergentagent.com/jobs/69aac895-42cc-43ce-b8ea-745bf2a06245/images/8092d74650afd37cd07100fa5b077ece5948b68fb3daa90be3b3f1605708321a.jpeg",
  foryou: "https://static.prod-images.emergentagent.com/jobs/69aac895-42cc-43ce-b8ea-745bf2a06245/images/038dd62a702c132e9182a486c9e74705be17a896cd6db8e726ea085725290b39.jpeg",
  faq: "https://static.prod-images.emergentagent.com/jobs/69aac895-42cc-43ce-b8ea-745bf2a06245/images/979dcd9e6229e2436aa7fdd26109125c6a29174884143b5cc854ccf2f0e549ec.jpeg",
};

// Custom domain illustrations for the Framework page
export const DOMAIN_IMG = {
  execution: "https://static.prod-images.emergentagent.com/jobs/69aac895-42cc-43ce-b8ea-745bf2a06245/images/8d55e857a6f893763b0359a8bcce8fb240166042913c83652bd5634128eaea60.jpeg",
  cognitive: "https://static.prod-images.emergentagent.com/jobs/69aac895-42cc-43ce-b8ea-745bf2a06245/images/2e0bdab18cfdaedace8695124d26af908d1aa9a2d5f2fc8382c55aff35c18143.jpeg",
  growth: "https://static.prod-images.emergentagent.com/jobs/69aac895-42cc-43ce-b8ea-745bf2a06245/images/b2b8300af3d514c0c37eedeb63a52ce0c05acaa42d9b5754b0758e1dcd51625a.jpeg",
};
